import { createContext } from "react";

const CounselingContext = createContext();

export default CounselingContext;
